import React from "react";
import PublicNav from "@/components/PublicNav";
import Footer from "@/components/Footer";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
function GoogleIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" aria-hidden="true">
      <path fill="#FFC107" d="M21.8 10.2H12v3.8h5.6c-.5 2.3-2.5 3.7-5.6 3.7-3.4 0-6.2-2.8-6.2-6.2S8.6 5.3 12 5.3c1.5 0 2.9.5 4 1.5l2.7-2.7C16.9 2.4 14.5 1.5 12 1.5 6.2 1.5 1.5 6.2 1.5 12S6.2 22.5 12 22.5c6 0 10.3-4.2 10.3-10.4 0-.7-.1-1.3-.2-1.9z"/>
      <path fill="#FF3D00" d="M2.6 6.6l3.1 2.3C6.5 7 9 5.3 12 5.3c1.5 0 2.9.5 4 1.5l2.7-2.7C16.9 2.4 14.5 1.5 12 1.5 8 1.5 4.5 3.5 2.6 6.6z"/>
      <path fill="#4CAF50" d="M12 22.5c2.5 0 4.8-.9 6.6-2.4l-3-2.5c-.9.6-2.1 1-3.6 1-3 0-5.5-2-6.3-4.7L2.6 16.4C4.5 19.9 8 22.5 12 22.5z"/>
      <path fill="#1976D2" d="M21.8 10.2H12v3.8h5.6c-.3 1.3-1 2.4-2 3.1l3 2.5c1.7-1.6 2.8-4 2.8-7.5 0-.7-.1-1.3-.2-1.9z"/>
    </svg>
  );
}

export default function Login() {
  const startGoogle = (intent) => {
    if (intent === "buyer" || intent === "seller") {
      window.localStorage.setItem("signup_intent", intent);
    }
    const redirectUrl = window.location.origin + "/auth/callback";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="bg-parchment min-h-screen flex flex-col" data-testid="login-page">
      <PublicNav />
      <section className="flex-1 max-w-7xl w-full mx-auto px-6 md:px-10 py-20 grid md:grid-cols-12 gap-14 items-start">
        <div className="md:col-span-7">
          <div className="overline">Corporate Intake — Vetted Access</div>
          <h1 className="h-serif text-5xl md:text-6xl text-ink mt-4 leading-[1.05]">
            Sign in to request access to the brokerage platform.
          </h1>
          <p className="text-sub mt-6 max-w-xl leading-relaxed">
            We use Google identity for sign-in to keep the authentication layer
            simple and verifiable. After you sign in, your account enters our
            intake queue. An analyst reviews your firm against our compliance
            framework before unlocking any commercial conversation.
          </p>
          <ul className="mt-8 space-y-3 text-sub text-sm">
            <li>· Google sign-in (no password to manage)</li>
            <li>· Manual admin approval — typical turnaround under 24 business hours</li>
            <li>· Mandatory KYC + OFAC + OpenSanctions screening before any deal</li>
            <li>· Account remains in a read-only holding state until cleared</li>
          </ul>
        </div>

        <div className="md:col-span-5 space-y-5">
          <div className="border border-line bg-parchment2 p-8">
            <div className="overline">Buyer intake</div>
            <h2 className="h-serif text-2xl text-ink mt-2">I&apos;m here to buy</h2>
            <p className="text-sub text-sm mt-3 leading-relaxed">
              Submit an ICPO with a Bank Comfort Letter once cleared. Pricing
              and the logistics calculator unlock after approval.
            </p>
            <button
              onClick={() => startGoogle("buyer")}
              className="btn-primary w-full mt-6 justify-center"
              data-testid="login-google-btn"
            >
              <GoogleIcon />
              Continue as Buyer
            </button>
          </div>

          <div className="border border-line bg-parchment2 p-8">
            <div className="overline">Supplier intake</div>
            <h2 className="h-serif text-2xl text-ink mt-2">I&apos;m here to supply</h2>
            <p className="text-sub text-sm mt-3 leading-relaxed">
              Refineries, mills, origins — onboard your trade profile and receive
              sanitized requests from vetted buyers.
            </p>
            <button
              onClick={() => startGoogle("seller")}
              className="btn-ghost w-full mt-6 justify-center"
              data-testid="login-supplier-btn"
            >
              <GoogleIcon />
              Continue as Supplier
            </button>
            <p className="text-xs text-sub mt-5 leading-relaxed">
              Suppliers go through the same KYC + sanctions screening as buyers
              and sign a master NCNDA, commission agreement, AML attestation and
              code of conduct before any deal is shown.
            </p>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}
